const FailedIcon = () => {
  return (
    <svg viewBox="0 0 18 18">
      <path
        d="M56.367,47.367a9,9,0,1,0,9,9A9,9,0,0,0,56.367,47.367Zm1.06,9,2.47,2.47A.75.75,0,0,1,58.837,59.9l-2.47-2.47L53.9,59.9a.75.75,0,0,1-1.061-1.061l2.47-2.47-2.47-2.47A.75.75,0,0,1,53.9,52.837l2.47,2.47,2.47-2.47A.75.75,0,0,1,59.9,53.9Z"
        transform="translate(-47.367 -47.367)"
      />
    </svg>
  );
};

export default FailedIcon;
